/**
 * Maintained by Sandon.
 */
import SySelect from './src/select.vue'
export default SySelect
